import { Fragment, useEffect, useMemo, useState } from "react";
import ArticlePreview from "../../../components/ui/blog/ArticlePreview";
import { getArticleList } from "../../../api/blog/blogAPI";
import Filter from "../../../components/ui/filters/Filter";
import ProductRecommendation from "../../common/recommendations/ProductRecommedation";
import LoadingPlaceholder from "../../../components/ui/loading/LoadingPlaceholder";
import { getLanguageContent } from "../../../utils/language/languageSelector";
import { FILTER_SCHEMA } from "../../../utils/schemas/language/components/filterSchema";

function Blog() {
  const filterContent = getLanguageContent(FILTER_SCHEMA);
  const [loading, setLoading] = useState(true);
  const [articles, setArticles] = useState([]);
  const [filters, setFilters] = useState({
    category: "",
  });

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
  };

  async function getArticles() {
    setLoading(true);
    const apiUrl = "blog/article";

    try {
      const response = await getArticleList(apiUrl);
      if (response.ok) {
        const responseData = await response.json();
        // We keep the data flat here
        setArticles(responseData.data || []);
      } else {
        console.error("Failed to fetch articles:", response.status);
      }
    } catch (error) {
      console.error("Error fetching articles:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    getArticles();
  }, []);

  // 1. Calculate unique categories dynamically for the Filter component
  const dynamicCategories = useMemo(() => {
    const uniqueStrings = [...new Set(articles.map((a) => a.category_display))];
    const filteredStrings = uniqueStrings.filter(Boolean);

    // Format them into the object structure the Filter component needs
    return [
      { value: "", label: "All Categories" },
      ...filteredStrings.map((cat) => ({ value: cat, label: cat })),
    ];
  }, [articles]);

  // 2. Filter the articles based on the selection
  const filteredArticles = useMemo(() => {
    if (!filters.category || filters.category === "") {
      return articles;
    }
    return articles.filter((a) => a.category_display === filters.category);
  }, [articles, filters.category]);

  return (
    <Fragment>
      <div id="hybrid-container">
        {/* LEFT SIDE: Logic is moved inside here */}
        <div className="hybrid-container-left">
          {loading ? (
            <div className="articles-container">
              {/* 1. Placeholder for Filter */}
              <LoadingPlaceholder rows={1} type="line" />
              {/* 2. Grid of Skeletons to maintain page height */}
              <LoadingPlaceholder rows={1} type="card-large" />
            </div>
          ) : (
            <>
              <Filter
                filters={filters}
                filterTitle={filterContent.blog.title}
                onFilterChange={handleFilterChange}
                visibleFilters={["category"]}
                statusOptions={dynamicCategories}
              />
              <div className="articles-container">
                <div className="article-grid">
                  {filteredArticles.map((article) => (
                    <ArticlePreview
                      key={article.id}
                      article_id={article.id}
                      creative_url={article.creative}
                      title={article.title}
                    />
                  ))}
                </div>
              </div>
            </>
          )}
        </div>

        {/* RIGHT SIDE: Always visible, never toggles */}
        <div className="hybrid-container-right">
          <ProductRecommendation />
        </div>
      </div>
    </Fragment>
  );
}

export default Blog;
